import React, { PureComponent } from 'react';
import { pagesApi } from '../../apis/PagesApi';
import VideoItem from '../Videos/VideoItem';
import { ReactComponent as IcLoading } from '../../assets/icons/ic-loading-1.svg';

class MbVideoList extends PureComponent {
   state = {
      pageNo: 0,
      pageSize: 10,
      sort: 'updated_at:desc',
      data: [],
      finished: false,
      isLoading: true,
   }
   _mouted = false;
   abortController = null;


   componentWillUnmount() {
      this._mouted = false;
      if (this.abortController) {
         this.abortController.abort();
      }
      // window.removeEventListener('scroll', this.scrollToLoadContinues);
   }

   componentDidMount() {
      this._mouted = true;
      this.abortController = new window.AbortController();
      this.loadData(this.state.pageNo, this.state.pageSize);

      window.addEventListener('scroll', this.scrollToLoadContinues);
   }

   scrollToLoadContinues = async () => {
      if (!this.state.finished && this.checkedRef) {
         let checkedRefPosition = this.checkedRef.getBoundingClientRect();
         if (checkedRefPosition.top <= document.documentElement.clientHeight) {
            if (!this.state.isLoading) {
               await this.setState({ isLoading: true });
               setTimeout(async () => {
                  this.loadData(this.state.pageNo + 1, this.state.pageSize, true);
               }, 100);
            }
         }
      }
   }

   loadData = async (pageNo, pageSize, isLoadNext) => {
      const { sort } = this.state;

      const requestBody = {
         start: pageNo * pageSize,
         limit: pageSize,
         sort: sort,
      };
      if (this._mouted) {
         const responseList = await pagesApi.getVideoList(requestBody, this.abortController);
         let finished = true;
         if (responseList && this._mouted) {
            if (responseList.length >= pageSize) {
               finished = false;
            }
            let data = [];
            if (isLoadNext) {
               data = [...this.state.data, ...responseList];
            } else {
               data = responseList;
            }
            this.setState({
               data: data,
            });
         }
         this.setState({
            finished,
            isLoading: false,
         });
      }
   }

   setContainerRef = (r) => {
      this.containerRef = r;
   }
   setCheckedRef = (r) => {
      this.checkedRef = r;
   }


   render() {
      return (
         <div className="mb-video-list">
            {
               this.state.data.map(item => {
                  return (
                     <div className="thumbnail-item animate__animated animate__zoomIn" key={item.id}>
                        <div className="preview-video-thumb">
                           {
                              item.url &&
                              <VideoItem url={item.url} />
                           }
                        </div>
                     </div>
                  )
               })
            }
            {
               (this.state.data.length >= this.state.pageSize && !this.state.finished) &&
               <div ref={this.setCheckedRef}
                  style={{
                     height: '40px',
                     display: 'flex',
                     width: '100%',
                     alignItems: 'center',
                     justifyContent: 'center',
                     color: '#868686'
                  }}>
                  <IcLoading />
               </div>
            }
         </div>
      );
   }
}

export default MbVideoList;